export const learnMoreLink = 'https://support.syte.ai/space/SP/2735768893/ER.+Overview';
